import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import TypewriterText from '../components/TypewriterText';

const WaitlistConfirmation = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen bg-[#ffffeb] flex flex-col"
      style={{
        backgroundImage: `
          repeating-linear-gradient(0deg, transparent, transparent 7px, rgba(7, 127, 93, 0.03) 7px, rgba(7, 127, 93, 0.03) 8px),
          repeating-linear-gradient(90deg, transparent, transparent 7px, rgba(7, 127, 93, 0.03) 7px, rgba(7, 127, 93, 0.03) 8px)
        `
      }}
    >
      {/* Content */}
      <div className="flex-1 flex items-center justify-center px-4 py-4">
        <div className="w-full max-w-md">
          <div className="bg-white border-4 border-[#077f5d] p-8" style={{ boxShadow: '6px 6px 0 #077f5d' }}>

            <div className="text-center mb-8">
              <h1
                className="text-2xl text-center text-[#077f5d] mb-4 uppercase"
                style={{ fontFamily: "'Press Start 2P'", lineHeight: '1.3' }}
              >
                Yes! Kamu Masuk Daftar Tunggu!
              </h1>
              
              <div className="space-y-3 mb-4">
                <TypewriterText
                  texts={[
                    'Fittory lagi disiapin biar pas banget buat kamu.',
                    'Tunggu aja kabar dari kita dan siap-siap hidup finansial yang lebih santuy!',
                    'Kasih tau temen biar mereka nggak ketinggalan ;)'
                  ]}
                  speed={35}
                  delayBetween={500}
                  showCursor={true}
                  className="text-[#1a1a1a] font-mono text-center"
                  onFinish={() => console.log('Typing done')}
                  startOnView={true}
                />
              </div>
            </div>

            {/* Go to Login Button */}
            <button
              type="submit"
              onClick={() => navigate('/login')}
              className="w-full bg-[#3cbe8c] text-white px-8 py-4 border-2 border-[#077f5d] font-bold uppercase"
              style={{
                fontFamily: "'Press Start 2P', monospace",
                fontSize: '12px',
                boxShadow: '6px 6px 0 #077f5d'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '4px 4px 0 #077f5d';
                e.currentTarget.style.transform = 'translate(-2px, -2px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '6px 6px 0 #077f5d';
                e.currentTarget.style.transform = 'translate(0, 0)';
              }}
            >
              Go to Login
            </button>

            {/* Additional Info */}
            <p className="mt-6 text-center text-xs text-[#077f5d] font-mono">
              Ada pertanyaan? 
              <br/>
              Kontak: info@fittory.id
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaitlistConfirmation;
